import { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import CurrencyService from "../../../services/CurrencyService.js";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
    md: {
      span: 9,
    },
    lg: {
      span: 10,
    },
    xl: {
      span: 10,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
    md: {
      span: 15,
    },
    lg: {
      span: 14,
    },
    xl: {
      span: 14,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
export default function CurrencyModalForm({
  isModalVisible,
  handleOk,
  handleCancel,
  currencyTarget = null,
}) {
  const [form] = Form.useForm();
  const [formField, setformField] = useState(null);

  useEffect(() => {
    if (currencyTarget) {
      setformField([
        { name: ["name"], value: currencyTarget.name },
        { name: ["shortName"], value: currencyTarget.shortName },
      ]);
    }
  }, [currencyTarget]);

  const onFinish = (values) => {
    let currencyR = { ...values };
    if (currencyTarget) {
      currencyR.id = currencyTarget.id;
      CurrencyService.updateCurrency(currencyR)
        .then((res) => {
          if (res.data?.success) {
            message.success("Moneda actualizada.", 3);
            handleOk();
          } else {
            message.error(
              "No se pudo actualizar la moneda. " + res.data?.description,
              5
            );
          }
        })
        .catch((e) => {
          console.log("error", e.message);
          message.error("Hubo un error. " + e.message, 5);
        });
    } else {
      CurrencyService.createCurrency(currencyR)
        .then((res) => {
          if (res.data?.success) {
            message.success("Moneda registrada.", 3);
            handleOk();
          } else {
            message.error(
              "No se pudo registar la moneda. " + res.data?.description,
              5
            );
          }
        })
        .catch((e) => {
          console.log("error", e.message);
          message.error("Hubo un error. " + e.message);
        });
    }
  };

  return (
    <Modal
      title="Registrar Moneda"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      footer={null}
    >
      <Form
        className="form"
        {...formItemLayout}
        form={form}
        fields={formField}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
      >
        <Form.Item
          name="name"
          label="Nombre de la Moneda"
          rules={[
            {
              required: true,
              message: "Por favor ingresa el nombre de la moneda.",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="shortName"
          label="Simbolo"
          rules={[
            {
              required: true,
              message: "Por favor ingresa el simbolo de la moneda",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            Aceptar
          </Button>
          <Button
            type="secondary"
            htmlType="button"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancelar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
